import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/companies/CompaniesCatalog.tsx");
